<template>
  <div class="solution-face-in">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionFaceIn"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          FaceIn人脸核身是一组对用户身份信息真实性进行验证审核的服务套件，提供各类认证功能模块，包含证件 OCR 识别、活体检测、人脸1:1对比等能力，以解决行业内大量对用户身份信息核实的需求，广泛应用于社保、金融、保险等领域。
        </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          FaceIn人脸核身为您提供身份证 OCR、活体检测、1:1人脸比对的配套服务，引擎能力领先，并且可根据需求灵活组合。
        </div>
      </div>
      <div class="facein-img-intro">
        <div class="img-facein-function"></div>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="facein-process-nav">
        <div class="nav-live-facein" :class="{'active' : activeFacein}" @click="activeFacein = true">活体人脸核身</div>
        <div class="nav-live-compare" :class="{'active' : !activeFacein}" @click="activeFacein = false">活体人脸比对</div>
      </div>
      <div class="facein-img-intro">
        <div class="img-facein-process-facein" v-if="activeFacein"></div>
        <div class="img-facein-process-compare" v-else></div>
      </div>
    </div>
    <div id="anchor-3" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionFaceIn"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-4" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[4]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionFaceIn"></application-scene>
      </div>
    </div>
    <div id="anchor-5" class="items-details client-case">
      <div class="solution-title">
        {{AnchorsItems[5]}}
      </div>
      <div class="client-case-facein">
        <div class="case-info">
          <div class="facein-title">微众银行</div>
          <div class="facein-content">
            微众银行是国内首家互联网银行，微众银行APP的远程核身验证即应用了优图的人脸核身技术。李克强总理视察微众银行时当场见证了其人脸核身的演示。优图凭借业内领先的人脸技术，在智能手机上安全、有效地解决了用户远程实名制核身验证的难题，国内首创。
          </div>
        </div>
        <div class="case-img"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      AnchorsItems: ['方案介绍', '产品功能', '方案流程', '方案优势', '应用场景', '典型案例'],
      secondNavFixed: false,
      activeFacein: true,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-face-in {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    &.client-case{
      background-color: rgb(245, 246, 247);
      padding-bottom: 100px;
    }
  }
  .solution-title{
    padding-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro{
    width: 1170px;
    margin: 0 auto;
    .content{
      font-size: 16px;
      color: #212121;
      line-height: 1.8;
      text-align: justify;
      margin-bottom: 26px;
    }
    .img-title {
      font-size: 22px;
      color: #212121;
      margin-top: 58px;
      margin-bottom: 26px;
      line-height: 1.0;
    }
  }
  .facein-process-nav {
    margin: 0 auto;
    width: 1200px;
    text-align: center;
    .nav-live-facein, .nav-live-compare {
      cursor: pointer;
      display: inline-block;
      margin: 0 45px;
      font-size: 17px;
      line-height: 50px;
      padding-top: 5px;
      &.active {
        color: #00a6ff;
        border-bottom: 4px solid #00a6ff;
      }
      &:hover {
        color: #00a6ff;
        border-bottom: 4px solid #00a6ff;
      }
    }
  }
  .facein-img-intro{
    .img-facein-function{
      width: 1170px;
      height: 460px;
      margin: 0 auto;
      background: url(./img/intro/pic_function.jpg);
    }
    .img-facein-process-facein{
      width: 1170px;
      height: 709px;
      margin: 0 auto;
      background: url(./img/process/pic_rlhs.jpg);
    }
    .img-facein-process-compare{
      width: 1170px;
      height: 709px;
      margin: 0 auto;
      background: url(./img/process/pic_htbd.jpg);
    }
  }
  .application-container{
    width: 1170px;
    margin: 0 auto 40px;
    font-size: 0;
    .application-item-facein{
      display: inline-block;
      vertical-align: top;
      width: 360px;
      height: 322px;
      background-position: center 10px;
      background-repeat: no-repeat;
      color: #242526;
      margin-right: 45px;
      .application-item-title{
        padding-top: 180px;
        font-size: 24px;
        text-align: center;
      }
      .application-item-content{
        font-size: 16px;
        line-height: 1.8;
        margin-top: 22px;
        text-align: justify;
      }
      &.no-margin-right{
        margin-right: 0;
      }
    }
  }
  .client-case-facein{
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0;
    .case-info, .case-img{
      display: inline-block;
      height: 340px;
      width: 585px;
      vertical-align: top;
    }
    .case-img{
      background-image: url('./img/case/facein_face_pic5.jpg');
    }
    .case-info {
      padding: 58px 36px;
      background: #ffffff;
      line-height: 40px;
      border: #f0f0f0 1px solid;
      border-right: none;
      .facein-title{
        line-height: 40px;
        font-size: 26px;
        padding-left: 138px;
        background-image: url(./img/case/facein_face_logowebank.png);
        background-repeat: no-repeat;
        background-position: 0 center;
      }
      .facein-content {
        margin-top: 28px;
        font-size: 16px;
        width: 510px;
        text-align: justify;
        line-height: 1.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionFaceIn.vue